import LayoutContainer from "../../components/Containers/LayoutContainer";
import ZigsawChallengeData from "./ZigsawChallengeData";

const Zigsaw_Challenge = () => {
  return (
    <LayoutContainer title="Zigsaw Challenge">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Zigsaw Challenge Data
        </h2>
      </div>
      <ZigsawChallengeData />
    </LayoutContainer>
  );
};

export default Zigsaw_Challenge;
